// Единая логика статусов направления (N-017). Источник правды для всех страниц админки.
// active без clinic_confirmed_at = "Направлен" (ждём первой ночной проверки МИС),
// active с clinic_confirmed_at = "Подтверждён" (проверку прошёл, ждём оплаты).
export function referralLabel(status, clinicConfirmedAt) {
  if (status === 'primary_done') return 'Дошёл';
  if (status === 'duplicate') return 'Дубль';
  if (status === 'timed_out') return 'Не дошёл';
  if (status === 'inactive') return 'Неактивно';
  if (status === 'active') return clinicConfirmedAt ? 'Подтверждён' : 'Направлен';
  return status;
}

export const REFERRAL_STATUS_OPTIONS = [
  ['', 'Все статусы'],
  ['active', 'Направлен / Подтверждён'],
  ['primary_done', 'Дошёл'],
  ['duplicate', 'Дубль'],
  ['timed_out', 'Не дошёл'],
  ['inactive', 'Неактивно'],
];
